import axios from "axios";

// Base URL for the API
export const devUrl = "https://backend-dev.alpha-futures.com/"; //dev server
export const liveUrl = "https://backend.alpha-futures.com/"; //prod server
export const uatUrl = "https://backend-uat.alpha-futures.com/"; //uat server
// export const baseUrl = "https://backend.alpha-futures.com/"; //prod server

export const baseUrl = (() => {
  const { hostname } = window.location;
  if (hostname === "localhost") {
    return liveUrl;
  } else if (hostname === "user-dev.alpha-futures.com") {
    return devUrl; //dev server
  } else if (hostname === "user-uat.alpha-futures.com") {
    return uatUrl;
  } else if (hostname === "app.alpha-futures.com") {
    return liveUrl;
  }
  return liveUrl;
})();

// Create an axios instance with the base URL and a timeout
const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
});

// Function to set the idToken in axios headers
export const setIdToken = (idToken) => {
  if (idToken) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

// Intercept request to add the Authorization header
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercept response to handle any response errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
